import { createSlice } from '@reduxjs/toolkit';

import { EventsActions } from '../types';

import { eventsReducers } from './actions';
import { initialState } from './events-actions.state';

export const eventsActions = createSlice({
  name: 'eventsActions',
  initialState,
  reducers: {
    setEventsData: (
      state,
      payload: { type: string; payload: EventsActions },
    ) => {
      state.events = payload.payload.events;
      state.eventTags = payload.payload.eventTags || [];
      state.total = payload.payload.total;
    },
  },
  extraReducers: (builder) => {
    eventsReducers(builder);
  },
});

export const { setEventsData } = eventsActions.actions;

export const eventsActionsReducer = eventsActions.reducer;
